import { judgeQuoteIsCombineR2RScheme } from '../flagJudgement/quote';
import { estateAgentBusinessActivityCodeList } from './quote/accelerant';
export var getInsuranceQuestionIdByBusinessActivity = function getInsuranceQuestionIdByBusinessActivity(businessActivity, config) {
  var questionId = '';

  if ((config === null || config === void 0 ? void 0 : config.source) === 'estateAgent') {
    if (estateAgentBusinessActivityCodeList.includes(businessActivity) && !judgeQuoteIsCombineR2RScheme({
      promotionInfo: config === null || config === void 0 ? void 0 : config.promotionInfo
    })) {
      questionId = 'accelerant_estate_agents_declaration_1';
    }
  } else if ((config === null || config === void 0 ? void 0 : config.source) === 'accountancy') {
    if (['ACC-001'].includes(businessActivity)) {
      questionId = 'accelerant_accountants_declaration_1';
    } else if (['ACC-002'].includes(businessActivity)) {
      questionId = 'accelerant_accountants_declaration_2';
    } else if (['ACC-003'].includes(businessActivity)) {
      questionId = 'accelerant_accountants_declaration_3';
    }
  }

  return questionId;
};
export var getInsuranceQuestionIdByActivitySplit = function getInsuranceQuestionIdByActivitySplit(activityPercentage, config) {
  var questionId = ''; // count

  var keyList = Object.keys(activityPercentage || {});

  if (!!['ACT049', 'ACT063'].find(function (item) {
    return keyList.includes(item);
  })) {
    questionId = 'accelerant_accountants_declaration_3';
  } else if (!!['ACT030', 'ACT037'].find(function (item) {
    return keyList.includes(item);
  })) {
    questionId = 'accelerant_accountants_declaration_2';
  } else if (!!['ACT008', 'ACT010', 'ACT013', 'ACT023', 'ACT024', 'ACT059', 'ACT075', 'ACT111'].find(function (item) {
    return keyList.includes(item);
  })) {
    questionId = 'accelerant_accountants_declaration_1';
  } else {
    questionId = 'accelerant_accountants_declaration_1';
  }

  return questionId;
};